import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  private dictionary: Map<string, string> = new Map<string, string>();

  constructor() { }

  addDictionaryWord(word: string, description: string) {
    this.dictionary.set(word, description);
  }

  getDescription(word: string) {
    let description = this.dictionary.get(word);
    return description ? description : 'Not found';
  }
}
